export const fonts = {
    cursive:`font-family: 'Cedarville Cursive', cursive;`
}